module.exports = __webpack_public_path__ + "img/partners.d5edf95.png";